var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen && _vm.componentName
    ? _c(
        "PopupUI",
        {
          staticClass: "auth-ui",
          attrs: {
            small: true,
            "no-inner-indent": true,
            "prevent-close-event": _vm.preventClosePopup
          },
          on: { "on-close": _vm.hideAuth }
        },
        [
          _vm.componentName
            ? _c(_vm.componentName, {
                tag: "component",
                attrs: {
                  "type-auth": _vm.typeAuth,
                  from: _vm.from,
                  back: _vm.back,
                  phone: _vm.phone,
                  code: _vm.code,
                  "code-phone": _vm.codePhone,
                  "number-phone": _vm.numberPhone,
                  "country-id": _vm.countryId,
                  "location-id": _vm.locationId,
                  "country-code": _vm.countryCode,
                  "short-form-specialist": _vm.shortFormSpecialist,
                  "key-short-form": _vm.keyShortForm,
                  "hide-link-type-auth": _vm.hideLinkTypeAuth,
                  callback: _vm.callback,
                  subtitle: _vm.subtitle
                },
                on: { "set-action": _vm.setAction }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }